import React, { Component } from 'react';
import "./videoBox.css";

export default class Hero extends Component {
  constructor(props) {
      super(props);
      this.state = {
          componentReady: ''
      };
  }

  componentDidMount = () => {
    setTimeout(function() {
      this.setState(
				{
					componentReady: 'ready'
				}
		);

    }.bind(this), 10);
  }
  render() {
    let controls = !this.props.hideControls ? true : false;
    return (
      <div className={this.state.componentReady+' video-item'}
        style={{color:this.props.backgroundColor}}>
        <div className="video-container">
          <video className="video full-width" width="100%" controls={controls} autoPlay muted loop playsInline>
            <source src={this.props.video}></source>
          </video>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/alpineComponents/videoBox/index.js